import { render, staticRenderFns } from "./Stepper4.vue?vue&type=template&id=49a5ca48&scoped=true&"
import script from "./Stepper4.vue?vue&type=script&lang=js&"
export * from "./Stepper4.vue?vue&type=script&lang=js&"
import style0 from "./Stepper4.vue?vue&type=style&index=0&id=49a5ca48&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49a5ca48",
  null
  
)

export default component.exports